module.exports = __webpack_public_path__ + "static/media/slack-icon.f9d5e6af.svg";